export let Protocol;

(function (Protocol) {
  Protocol[Protocol["ID"] = 0] = "ID";
  Protocol[Protocol["SECP256K1"] = 1] = "SECP256K1";
  Protocol[Protocol["ACTOR"] = 2] = "ACTOR";
  Protocol[Protocol["BLS"] = 3] = "BLS";
})(Protocol || (Protocol = {}));
//# sourceMappingURL=protocol.js.map